module.exports = __webpack_public_path__ + "img/depmap_svg_V36.cb85a2e4.svg";